import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import AuthorFollowButton from '../AuthorFollowButton';
import AuthorNetworkInfoComponent from '../AuthorNetworkInfo';
import {ProfileThumb} from '../../Common/CardComponents';
import {Icon} from '../../Common/Icon';
import TooltipBehavior from '../../Common/TooltipBehavior';
import cx from '../../../styles';
import {buildMapping} from '../../../other/ActionMapper';
import configureStore from '../../../store';

const AuthorDescriptionComponent = ({author, ifSelf, t, handleRolesClick}) => {
    const [dropdown, setDropdown] = useState(false);
    const showMenu = () => {
        setDropdown(!dropdown)
    }
    const store = configureStore(null);  
    const actions = buildMapping(
        'profile',
        author.actions,
        {
            id: author.id,
            cardName: 'User Profile',
            authorId: author.id,
            authorName: author.fullname,
        },
        store.dispatch
    );

    return (

        <div className={cx("author-description-component")}>
            <section className={cx("post-section")}>
                <div className={cx("post-section-header")}>
                    <div className={cx("left")}>
                        <div className={cx(author.is_blocked === 1? 'blur' : '')}>
                            <ProfileThumb img={author.image ? author.image : ""} size="large" altName={`${author.fullname} profile icon`} />
                        </div>

                        <div className={cx("author-name")}>
                            {
                                author.rewards && author.rewards.level_name && author.is_blocked === 0 && 
                                <div className={cx('level-name')}>
                                    <img src={author.rewards.level_image} alt={author.rewards.level_name} />
                                    <span>{author.rewards.level_name}</span>
                                </div>
                            }
                            <h1>
                                {author.fullname + ', '}<span>{author.location} </span>
                            </h1>
                        </div>
                    </div>

                    <div className={cx("right")}>
                        {
                            !ifSelf && actions && actions.length > 0 && 
                            <div>
                                <TooltipBehavior isOpen={dropdown} onClose={()=>setDropdown(false)}>
                                    <span className={cx("pointer-click")} onClick={showMenu}>
                                        <Icon className={cx("not-mobile")} name="dot-more-regular-gray-sm" />
                                        <Icon className={cx("only-mobile")}  name="dot-more-vertical-regular-gray-sm" />
                                    </span>
                                    <div className={cx("tooltip-card", (dropdown ? "active" : ""))} >
                                        <ul>
                                        {
                                            actions.map((action, key)=>{
                                                return(
                                                    <li className={cx("pointer-click")} key={key}>{action.title}</li>                         
                                                )
                                            })
                                        }
                                        </ul>
                                    </div>
                                </TooltipBehavior>
                            </div>
                        }
                        { 
                            ifSelf && 
                            <a href={'/user/edit/basic'} aria-label="Edit button" rel="nofollow">
                                <Icon name="edit-regular-gray-sm" />
                            </a> 
                        }
                        {/* { 
                            ifSelf && 
                            <a href={`/user/edit/${author.slug}/basic`} aria-label="Edit button" rel="nofollow">
                                {"NewEdit"}
                            </a> 
                        } */}
                    </div>
                </div>

                {
                    author.roles && author.roles.length > 0 && author.is_blocked === 0 && 
                    <div className={cx('designation')}>
                        {
                            author.roles.map((role) => {
                                return (
                                    <span key={role.id} style={{ borderColor: role.tag_color_code, background: role.tag_color_code}} onClick={() => handleRolesClick(true)}>{role.tag}</span>
                                )
                            }) 
                        }
                    </div>
                }

                <div className={cx('only-mobile', 'follow-wrap')}>
                    <AuthorNetworkInfoComponent author={author} />
                </div>

                {
                    author.tagline && author.is_blocked === 0 && 
                    <div className={cx("post-section-body")}>
                        <h2>{t('menu_about') + ' ' + author.fullname}</h2>
                        <p>{author.tagline}</p>
                        <p>{author.description}</p>
                    </div>
                }

                {
                    !ifSelf && author.is_blocked === 0 && 
                    <AuthorFollowButton author={author} />
                }

                {
                    author.is_blocked === 1 && 
                    <div className={cx('user-block-text')}>This user is blocked!</div>
                }
            </section>
        </div>
    );
}

export default AuthorDescriptionComponent;
